var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',[_c('h3',[_vm._v("Restoring tool")]),_c('div',{staticClass:"row"},[_c('RestoreLocations')],1),_c('div',{staticClass:"row"},[_c('RestoreDocumentsFromLocation')],1),_c('div',{staticClass:"row"},[_c('ReEnableLoopIdentified')],1),_c('div',{staticClass:"row"},[_c('RestoreUserCampaignCalendar')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }